import { Component, Input } from '@angular/core';
import { WhiskeyItem } from '../../menu.model';

@Component({
  selector: 'bourbon',
  templateUrl: './bourbon.component.html',
  styleUrls: ['./bourbon.component.scss']
})
export class BourbonComponent {

  @Input() whiskeyList: Array<WhiskeyItem> = [];
  @Input() activeSection: string | undefined;

  constructor() { }
}
